module.exports = __webpack_public_path__ + "static/img/banner2_en.c943929.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/banner2_en.png
// module id = D0EL
// module chunks = 1